import { render } from "./AddonImageCompare.vue?vue&type=template&id=c393ebb4&scoped=true"
import script from "./AddonImageCompare.vue?vue&type=script&lang=js"
export * from "./AddonImageCompare.vue?vue&type=script&lang=js"

import "./AddonImageCompare.vue?vue&type=style&index=0&id=c393ebb4&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c393ebb4"]])

export default __exports__